import React from 'react';
import './style.scss';
import ratingPrize1 from '../../../../../images/rating-prize-1.png';
import ratingPrize2 from '../../../../../images/rating-prize-2.png';

const RatingPrize1 = () => {
  return <article className="app-rating-prize app-rating-prize_1">
    <header className="app-rating-prize--header">1 - 3 место</header>
    <figure className="app-rating-prize--figure">
      {/* Ellipse */}
      <svg
          className="app-rating-prize--ellipse-1"
          width="126" height="45"
          viewBox="0 0 126 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="63" cy="22.5" rx="63" ry="22.5" fill="url(#paint0_linear_3546_1178)"/>
        <defs>
          <linearGradient
              id="paint0_linear_3546_1178" x1="28" y1="18.5" x2="126" y2="35"
              gradientUnits="userSpaceOnUse">
            <stop stopColor="#BC5EFF"/>
            <stop offset="1" stopColor="#FF0084"/>
          </linearGradient>
        </defs>
      </svg>

      {/* Circle */}
      <svg
          className="app-rating-prize--circle-1"
          width="78" height="78"
          viewBox="0 0 78 78"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
        <circle cx="39" cy="39" r="39" fill="url(#paint0_linear_3563_1115)"/>
        <defs>
          <linearGradient
              id="paint0_linear_3563_1115"
              x1="17.3333" y1="32.0667" x2="79.495" y2="35.8045"
              gradientUnits="userSpaceOnUse">
            <stop stopColor="#DFB4FE"/>
            <stop offset="1" stopColor="#FC75BB"/>
          </linearGradient>
        </defs>
      </svg>

      {/* Image */}
      <img src={ratingPrize1} alt="" className="app-rating-prize--image app-rating-prize--image_1"/>
    </figure>
    <div className="app-rating-prize--description">
      Наушники Маршал<br/>
      Энциклопедия<br/>
      Календарь<br/>
      Комикс<br/>
      Книга Ананси<br/>
      Кулон
    </div>
  </article>;
}

const RatingPrize2 = () => {
  return <article className="app-rating-prize app-rating-prize_2">
    <header className="app-rating-prize--header">4 - 10 место</header>
    <figure className="app-rating-prize--figure">
      {/* Ellipse */}
      <svg
          className="app-rating-prize--ellipse-2"
          width="126" height="82"
          viewBox="0 0 126 82"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="63" cy="41" rx="63" ry="41" fill="url(#paint0_linear_3546_1274)"/>
        <defs>
          <linearGradient
              id="paint0_linear_3546_1274" x1="28" y1="33.7111" x2="127.925" y2="42.9438"
              gradientUnits="userSpaceOnUse">
            <stop stopColor="#BC5EFF"/>
            <stop offset="1" stopColor="#00FFF7"/>
          </linearGradient>
        </defs>
      </svg>

      {/* Image */}
      <img src={ratingPrize2} alt="" className="app-rating-prize--image app-rating-prize--image_2"/>
    </figure>
    <div className="app-rating-prize--description">
      Яндекс Станция Лайт<br/>
      Книга Ананси<br/>
      Комикс<br/>
      Кулон
    </div>
  </article>;
}

const RatingPrize3 = () => {
  return <article className="app-rating-prize app-rating-prize_3">
    <header className="app-rating-prize--header app-rating-prize--header_small">
      10 случайных игроков,<br/>
      пригласивших<br/>
      трёх и более друзей
    </header>
    <div className="app-rating-prize--description">
      Энциклопедия<br/>
      Комикс<br/>
      Кулон
    </div>
  </article>;
}

export {
  RatingPrize1,
  RatingPrize2,
  RatingPrize3
}